(() => {
  'use strict';

  if (typeof ProductGallery === 'undefined' || ProductGallery.prototype.gemmariiRuntimePatched) return;

  ProductGallery.prototype.observeDynamicChanges = function () {
    const scope = this.container?.querySelectorAll ? this.container : document;
    if (!scope.querySelector?.('.product-media-gallery')) return;

    const observeRoot = scope === document
      ? document.querySelector('main') || document.body
      : scope;

    this.gemmariiMutationObserver?.disconnect?.();
    this.gemmariiMutationObserver = new MutationObserver((mutations) => {
      const galleryChanged = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some((node) =>
          node.nodeType === Node.ELEMENT_NODE
          && (node.matches?.('.product-media-gallery, .product-thumbnails')
            || node.querySelector?.('.product-media-gallery, .product-thumbnails'))
        )
      );

      if (!galleryChanged || this.gemmariiGalleryRefreshScheduled) return;
      this.gemmariiGalleryRefreshScheduled = true;

      requestAnimationFrame(() => {
        this.gemmariiGalleryRefreshScheduled = false;
        this.destroySwipers?.();
        this.mainGalleryContainers = scope.querySelectorAll('.product-media-gallery');
        this.thumbnailGalleryContainers = scope.querySelectorAll('.product-thumbnails');
        this.initAll?.();
      });
    });

    this.gemmariiMutationObserver.observe(observeRoot, { childList: true, subtree: true });
  };

  ProductGallery.prototype.setActiveSlider = function (activeIndex) {
    Object.values(this.gallerySwipers || {}).forEach((swiper) => swiper?.keyboard?.disable?.());
    this.gallerySwipers?.[activeIndex]?.keyboard?.enable?.();
  };

  ProductGallery.prototype.setActiveSliderSimple = ProductGallery.prototype.setActiveSlider;
  ProductGallery.prototype.gemmariiRuntimePatched = true;
})();
